import React from "react";

const OmbreProcess = () => {
  return (
    <div className="nailExtensionHeading">
      <h4>Our Ombre Gel Nail Polish Process</h4>
      <p>
        Creating the perfect{" "}
        <a href="https://scentlifestyle.com/ombre-gel-nail-polish">
          ombre gel nails
        </a>{" "}
        requires skill and precision. Here’s a step-by-step overview of our
        process:
      </p>
      <ul>
        <li>
          1. <span>Preparation:</span>We begin by cleaning and shaping your
          nails to your desired length and shape. The cuticles are carefully
          pushed back, and the nails are lightly buffed to create a smooth
          surface for the gel polish.
        </li>
        <li>
          2. <span> Base Coat Application: </span> A base coat is applied to
          your nails to ensure the gel polish adheres properly and lasts longer.
          This also helps in protecting your natural nails.
        </li>
        <li>
          3. <span>Color Application: </span> The ombre effect is created by
          applying multiple layers of{" "}
          <a href="https://scentlifestyle.com/chrome-gel-nail-polish">
            gel polish
          </a>{" "}
          in a gradient pattern. This involves blending the colors seamlessly
          from light to dark using a brush or sponge. Each layer is cured under
          a UV or LED lamp to set the polish.
        </li>
        <li>
          4. <span>Top Coat Application:</span> Once the desired ombre effect is
          achieved, a top coat is applied to seal the polish and add a
          high-gloss finish. This top coat also protects your nails from
          chipping and ensures the polish lasts longer.
        </li>
        <li>
          5. <span>Final Touches:</span> After curing the top coat, we perform a
          final check to ensure your nails look perfect. The nails are then
          wiped with a cleanser to remove any sticky residue, leaving them shiny
          and flawless.
        </li>
      </ul>
    </div>
  );
};

export default OmbreProcess;
